export const navCopy = {
  skip_to_content: "메인 컨텐츠로 바로가기",
  nav_documentation: "문서",
  nav_documentation_short: "문서",
  nav_download: "다운로드",
  nav_community: "커뮤니티",
  nav_playground: "플레이그라운드",
  nav_playground_short: "플레이그라운드",
  nav_handbook: "핸드북",
  nav_tools: "도구",
  nav_search_placeholder: "검색",
  nav_search_aria: "TypeScript 사이트에서 검색",
  // let me know if you can't make this work in your lang:
  // TypeScript X.Y [stable][between?]Z.Y[beta/rc]
  nav_version_stable_prefix: " 현재 사용 가능합니다.",
  nav_version_between: ", ",
  nav_version_beta_prefix: " 현재 베타 버전입니다.",
  nav_version_rc_prefix: " 현재 릴리즈 캔디데이트 (release candidate) 입니다.",
  nav_this_page_in_your_lang: "이 페이지의 한국어 버전이 있습니다.",
  nav_this_page_in_your_lang_open: "열기",
  nav_this_page_in_your_lang_no_more: "다시 보지 않기",
}
